import type { RootState } from '../index';

export const getModalType = (state: RootState) => state.modals.modalType;
export const getModalParams = (state: RootState) => state.modals.params;
export const getIsOpen = (state: RootState) => state.modals.isOpen; 